import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/usuario';

const userEndpoints = {
    getUsers: () => stipAxios.get(`${BASE_ENDPOINT}/setores`),
    getActiveInactiveUsers: () => stipAxios.get(`${BASE_ENDPOINT}/setores/ativos-inativos`),
    getUsersPagination: ({ page, size, request = {} }) => {
        return stipAxios.post(`${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`, request);
    },
    getUserInformations: (cdUsuario) => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/${cdUsuario}`),
    deleteUser: (params) => stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/delete`, params),
    saveUser: (params) => stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/save`, params),
    findUser: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find`),
    findUsers: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find-all`),
    getLineSecretary: () => stipAxios.get(`${BASE_ENDPOINT}/secretario-linhas`),
    getUsersByDepartment: (cdSetor) => stipAxios.get(`${BASE_ENDPOINT}/setor/${cdSetor}`),
};

export default userEndpoints;
